module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_hokkaido-319996e6539032b2c78e29d0a9aca77a.webp";